export const defaultCompetitorsTablePageSize = 10;
